// Module
var code = `<!-- template-angular/comparison-editions/comparison-editions-table.html -->
<!-- @see AppComponent -->
<div class="comparison-editions__filter mb-20">
    <div class="comparison-editions__select" data-comparison-editions-select>
        <div class="comparison-editions__select-control"
             [class.comparison-editions__select-control--open]="isOpen"
             (click)="toggleDropdown(\$event)">
            <div class="comparison-editions__select-panel">
                <div class="comparison-editions__select-panel-left">
                    <span class="comparison-editions__select-text">Выбрать редакции для сравнения</span>
                    @if (selectedItems?.length > 0) {
                        <span class="comparison-editions__select-counter">
                            {{ selectedItems?.length }}
                        </span>
                    }
                </div>
                <div class="comparison-editions__select-arrow" [class.comparison-editions__select-arrow--open]="isOpen">
                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.75 4.75L4.75 0.75L0.75 4.75" stroke="#1D1C1C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
        </div>
        @if (isOpen) {
            <div class="comparison-editions__select-dropdown" >
                <div class="comparison-editions__select-options-list">
                    <div class="mb-5">
                        @for (unit of units; track unit.id) {
                            <div
                                class="comparison-editions__select-option"
                            >
                                <label class="comparison-editions__select-option-label">
                                    <input
                                        class="comparison-editions__option-custom-input"
                                        type="checkbox"
                                        [checked]="isSelected(unit)"
                                        (change)="toggleItem(unit, \$event)"
                                        [disabled]="hasOneCheckboxChecked && isSelected(unit)"
                                    >
                                    <span class="comparison-editions__select-option-text">{{ unit.name }}</span>
                                </label>
                            </div>
                        }
                    </div>
                    <div class="comparison-editions__select-buttons">
                        <h4
                            (click)="selectedItems.length > 0 && onApplyEditions()"
                            [class.active]="selectedItems.length > 0"
                        >
                            Применить
                        </h4>
                    </div>
                </div>
            </div>
        }
    </div>
    <div class="comparison-editions__radio-panel-button">
        <div class="comparison-editions__radio-panel" [class.disabled]="selectedItems.length === 1">
            @for (radioItem of radioItems; track radioItem.id) {
                <div
                    class="comparison-editions__radio-panel-item"
                    [class.active]="radioItem.isSelected"
                    (click)="selectedItems.length !== 1 && onFilterDifferences(radioItem)"
                >
                    <h6>{{ radioItem.name }}</h6>
                </div>
            }
        </div>
        <button class="button button__link button__custom-shadow" (click)="onApplyReset()">
            <span class="reset">Сбросить</span>
            <span class="cross">
                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.00456 5.07682L6.69867 7.76787C6.84163
                     7.91067 7.03553 7.99089 7.2377 7.99089C7.43987 7.99089 7.63377 7.91067 7.77673 7.76787C7.91969
                      7.62507 8 7.4314 8 7.22946C8 7.02751 7.91969 6.83384 7.77673 6.69105L5.08159 4L7.77622
                       1.30895C7.84697 1.23825 7.90309 1.15431 7.94137 1.06195C7.97965 0.969579 7.99934 0.870584
                        7.99931 0.770615C7.99929 0.670646 7.97955 0.571661 7.94123 0.479311C7.90291 0.386961
                         7.84675 0.303054 7.77597 0.232382C7.70518 0.16171 7.62115 0.105657 7.52868
                          0.0674221C7.4362 0.0291874 7.3371 0.00952038 7.23701 0.00954394C7.13693
                           0.0095675 7.03783 0.0292811 6.94538 0.0675593C6.85292 0.105837
                            6.76892 0.161931 6.69817 0.232636L4.00456 2.92368L1.31044
                             0.232636C1.24018 0.159903 1.15611 0.101875 1.06316 0.0619387C0.970204 0.0220025
                              0.870218 0.000957515 0.769033 3.1921e-05C0.667849 -0.000893673 0.567493 0.0183185
                               0.473822 0.0565475C0.380151 0.0947765 0.29504 0.151257 0.223455 0.222693C0.15187
                                0.294128 0.0952451 0.379089 0.0568841 0.472618C0.0185232 0.566146 -0.000805523
                                 0.666369 2.57152e-05 0.767439C0.000856953 0.868509 0.0218314 0.968401 0.0617255
                                  1.06129C0.10162 1.15417 0.159634 1.23819 0.232384 1.30845L2.92752 4L0.232893
                                   6.69155C0.160142 6.76181 0.102128 6.84583 0.0622338 6.93871C0.0223397 7.0316
                                    0.00136495 7.13149 0.000533715 7.23256C-0.000297523 7.33363 0.0190312
                                     7.43385 0.0573921 7.52738C0.0957531 7.62091 0.152378 7.70587 0.223963
                                      7.77731C0.295548 7.84874 0.380659 7.90522 0.47433 7.94345C0.568001
                                      7.98168 0.668357 8.00089 0.769541 7.99997C0.870726 7.99904 0.970712
                                       7.978 1.06367 7.93806C1.15662 7.89813 1.24068 7.8401 1.31095
                                       7.76736L4.00456 5.07733V5.07682Z" fill="#232323"/>
                </svg>
            </span>
        </button>
    </div>
</div>
<div
    class="comparison-editions__table-comparison-scroll adaptive-margin-bottom"
    #scrollContainer
    (scroll)="onScroll(\$event)"
>
    <ngx-datatable
      #table
      class="bootstrap mobile-responsive advanced-table"
      [rows]="visibleRows"
      columnMode="force"
      [headerHeight]="50"
      [footerHeight]="50"
      rowHeight="auto"
      [externalPaging]="false"
      [rowClass]="getRowClass"
      [scrollbarV]="false"
      [scrollbarH]="scrollbarHorizontal"
      [virtualization]="false"
    >
        <ngx-datatable-column
            name="Функциональность"
            prop="name"
            [width]="widthFirstColumn"
            [minWidth]="90"
            [resizeable]="false"
        >
            <ng-template let-column="column" ngx-datatable-header-template>
                <span class="first-column-header">{{ column.name }}</span>
            </ng-template>

            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                <div
                    class="advanced-table__first-column-cell"
                    [class.advanced-table__first-column-cell--group]="row.isGroup"
                    (click)="toggleGroup(\$event,row)"
                >
                    <div
                        class="advanced-table__first-column-cell-header"
                        [class.advanced-table__first-column-cell-header--group]= "row.isGroup"
                    >
                        <h6>{{ value }}</h6>
                        @if (row.hint !== null) {
                            <span class="hint-question" [tp]="row.hint" tpPlacement="top" data-hint>
                                <svg
                                    width="19"
                                    height="19"
                                    viewBox="0 0 19 19"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <rect x="0.5" y="0.5" width="18" height="18" rx="9" stroke="#F8F8F8"/>
                                    <rect x="1.5" y="1.5" width="16" height="16" rx="8" fill="#D4D4D4"/>
                                    <path d="M6.4177 5.834L6.5437 5.68C6.86104 5.288 7.26237 4.98467 7.7477
                                     4.77C8.23304 4.55533 8.74637 4.448 9.2877 4.448C10.165
                                      4.448 10.9164 4.70467 11.5417 5.218C12.167 5.73133 12.475 6.44067
                                       12.4657 7.346C12.4564 8.214 12.195 8.89533 11.6817 9.39C11.1684 9.87533
                                        10.5104 10.1973 9.7077 10.356C9.69837 10.5987 9.6797 10.93 9.6517
                                         11.35C9.63304 11.77 9.61904 12.092 9.6097 12.316H8.6157L8.5317
                                          9.39C9.29704 9.38067 9.95504 9.18933 10.5057 8.816C11.0657 8.44267
                                           11.341 7.948 11.3317 7.332C11.3224 6.772 11.1124 6.34267 10.7017
                                            6.044C10.3004 5.736 9.8197 5.582 9.2597 5.582C8.46637 5.582
                                             7.81304 5.89467 7.2997 6.52L6.4177 5.834ZM8.5877 14.416C8.43837
                                              14.2667 8.3637 14.0893 8.3637 13.884C8.3637 13.6787 8.43837
                                               13.5013 8.5877 13.352C8.73704 13.2027 8.91437 13.128 9.1197
                                                13.128C9.32504 13.128 9.50237 13.2027 9.6517 13.352C9.80104
                                                 13.5013 9.8757 13.6787 9.8757 13.884C9.8757 14.0893 9.80104
                                                  14.2667 9.6517 14.416C9.50237 14.5653 9.32504 14.64 9.1197
                                                   14.64C8.91437 14.64 8.73704 14.5653 8.5877 14.416Z"
                                          fill="white"
                                    />
                                </svg>
                                <!--<span>{{row.hint}}</span>-->
                            </span>
                        }

                    </div>
                    @if (row.isGroup && radioItems[0].isSelected) {
                        <div>
                            <svg
                                class="advanced-table__toggle_button"
                                [class.active]="collapsedGroups.has(row.id)"
                                width="17" height="17"
                                viewBox="0 0 17 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M8.82617 0.900391L8.82617 15.9004" stroke="#1D1C1C" stroke-linecap="round"/>
                                <path d="M1 8.07422L16 8.07422" stroke="#1D1C1C" stroke-linecap="round"/>
                            </svg>
                            <svg
                                class="advanced-table__toggle_button"
                                [class.active]="!collapsedGroups.has(row.id)"
                                width="17" height="16" viewBox="0 0 17 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M1 7.57422L16 7.57422" stroke="#1D1C1C" stroke-linecap="round"/>
                                <path d="M1 7.57422L16 7.57422" stroke="#1D1C1C" stroke-linecap="round"/>
                            </svg>
                        </div>
                    }
                </div>
            </ng-template>
        </ngx-datatable-column>

        @for (unit of visibleUnits; track unit.id; let idx = \$index; let last = \$last; let total = \$count) {
            <ngx-datatable-column
                [name]="unit.name"
                [prop]="unit.field"
                [width]="widthColumn"
                [minWidth]="90"
                [resizeable]="false"
            >
                <!-- Кастомный header для каждой колонки -->
                <ng-template let-column="column" ngx-datatable-header-template>
                    <!-- Проверяем, является ли это одной из двух последних колонок -->
                    @if (unit.field === 'corporationPlusFstec' || unit.field === 'corporationPlus') {
                        <div class="advanced-table__custom-header-last-columns">
                            @if (unit.field === 'corporationPlusFstec') {
                                <div class="advanced-table__custom-header-with-icon mb-10">
                                    <h5 class="advanced-table__header-title">
                                        Корпорация + ФСТЭК
                                    </h5>
                                    @if (unit.isPro) {
                                        <svg width="35" height="18" viewBox="0 0 35 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect width="35" height="18" rx="3" fill="white"></rect>
                                            <path d="M3.98 14V3.92H12.149V14H10.462V5.502H5.667V14H3.98ZM13.5509
                                             14V3.92H17.7159C17.8139 3.92 17.9399 3.92467 18.0939 3.934C18.2479
                                             3.93867 18.3902 3.95267 18.5209 3.976C19.1042 4.06467 19.5849 4.25833
                                             19.9629 4.557C20.3455 4.85567 20.6279 5.23367 20.8099 5.691C20.9965
                                             6.14367 21.0899 6.64767 21.0899 7.203C21.0899 7.75367 20.9965 8.25767
                                             20.8099 8.715C20.6232 9.16767 20.3385 9.54333 19.9559 9.842C19.5779 10.1407
                                             19.0995 10.3343 18.5209 10.423C18.3902 10.4417 18.2455 10.4557 18.0869
                                             10.465C17.9329 10.4743 17.8092 10.479 17.7159 10.479H15.2379V14H13.5509ZM15.2379
                                             8.904H17.6459C17.7392 8.904 17.8442 8.89933 17.9609 8.89C18.0775 8.88067 18.1849
                                              8.862 18.2829 8.834C18.5629 8.764 18.7822 8.64033 18.9409 8.463C19.1042 8.28567
                                              19.2185 8.085 19.2839 7.861C19.3539 7.637 19.3889 7.41767 19.3889 7.203C19.3889
                                              6.98833 19.3539 6.769 19.2839 6.545C19.2185 6.31633 19.1042 6.11333 18.9409
                                              5.936C18.7822 5.75867 18.5629 5.635 18.2829 5.565C18.1849 5.537 18.0775 5.52067
                                               17.9609 5.516C17.8442 5.50667 17.7392 5.502 17.6459 5.502H15.2379V8.904ZM26.1953
                                               14.21C25.1873 14.21 24.3239 13.9907 23.6053 13.552C22.8866 13.1087 22.3336 12.4927
                                               21.9463 11.704C21.5636 10.9153 21.3723 10.0007 21.3723 8.96C21.3723 7.91933
                                               21.5636 7.00467 21.9463 6.216C22.3336 5.42733 22.8866 4.81367 23.6053
                                               4.375C24.3239 3.93167 25.1873 3.71 26.1953 3.71C27.2033 3.71 28.0666
                                               3.93167 28.7853 4.375C29.5086 4.81367 30.0616 5.42733 30.4443 6.216C30.8316
                                               7.00467 31.0253 7.91933 31.0253 8.96C31.0253 10.0007 30.8316 10.9153 30.4443
                                               11.704C30.0616 12.4927 29.5086 13.1087 28.7853 13.552C28.0666 13.9907 27.2033
                                               14.21 26.1953 14.21ZM26.1953 12.621C26.8719 12.6257 27.4343 12.4763 27.8823
                                               12.173C28.3349 11.8697 28.6733 11.4427 28.8973 10.892C29.1259 10.3413
                                               29.2403 9.69733 29.2403 8.96C29.2403 8.22267 29.1259 7.58333 28.8973 7.042C28.6733
                                               6.496 28.3349 6.07133 27.8823 5.768C27.4343 5.46467 26.8719 5.30833 26.1953 5.299C25.5186
                                               5.29433 24.9563 5.44367 24.5083 5.747C24.0603 6.05033 23.7219 6.47733 23.4933 7.028C23.2693
                                               7.57867 23.1573 8.22267 23.1573 8.96C23.1573 9.69733 23.2693 10.339 23.4933 10.885C23.7173
                                               11.4263 24.0533 11.8487 24.5013 12.152C24.9539 12.4553 25.5186 12.6117 26.1953 12.621Z"
                                                  fill="#E02F2E">

                                            </path>
                                        </svg>
                                    }
                                </div>
                            } @else {
                                <div class="advanced-table__custom-header-with-icon mb-10">
                                    <h5 class="advanced-table__header-title mb-10">{{ column.name }}</h5>
                                    @if (unit.isPro) {
                                        <svg width="35" height="18" viewBox="0 0 35 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect width="35" height="18" rx="3" fill="white"></rect>
                                            <path d="M3.98 14V3.92H12.149V14H10.462V5.502H5.667V14H3.98ZM13.5509
                                             14V3.92H17.7159C17.8139 3.92 17.9399 3.92467 18.0939 3.934C18.2479
                                             3.93867 18.3902 3.95267 18.5209 3.976C19.1042 4.06467 19.5849 4.25833
                                             19.9629 4.557C20.3455 4.85567 20.6279 5.23367 20.8099 5.691C20.9965
                                             6.14367 21.0899 6.64767 21.0899 7.203C21.0899 7.75367 20.9965 8.25767
                                             20.8099 8.715C20.6232 9.16767 20.3385 9.54333 19.9559 9.842C19.5779 10.1407
                                             19.0995 10.3343 18.5209 10.423C18.3902 10.4417 18.2455 10.4557 18.0869
                                             10.465C17.9329 10.4743 17.8092 10.479 17.7159 10.479H15.2379V14H13.5509ZM15.2379
                                             8.904H17.6459C17.7392 8.904 17.8442 8.89933 17.9609 8.89C18.0775 8.88067 18.1849
                                              8.862 18.2829 8.834C18.5629 8.764 18.7822 8.64033 18.9409 8.463C19.1042 8.28567
                                              19.2185 8.085 19.2839 7.861C19.3539 7.637 19.3889 7.41767 19.3889 7.203C19.3889
                                              6.98833 19.3539 6.769 19.2839 6.545C19.2185 6.31633 19.1042 6.11333 18.9409
                                              5.936C18.7822 5.75867 18.5629 5.635 18.2829 5.565C18.1849 5.537 18.0775 5.52067
                                               17.9609 5.516C17.8442 5.50667 17.7392 5.502 17.6459 5.502H15.2379V8.904ZM26.1953
                                               14.21C25.1873 14.21 24.3239 13.9907 23.6053 13.552C22.8866 13.1087 22.3336 12.4927
                                               21.9463 11.704C21.5636 10.9153 21.3723 10.0007 21.3723 8.96C21.3723 7.91933
                                               21.5636 7.00467 21.9463 6.216C22.3336 5.42733 22.8866 4.81367 23.6053
                                               4.375C24.3239 3.93167 25.1873 3.71 26.1953 3.71C27.2033 3.71 28.0666
                                               3.93167 28.7853 4.375C29.5086 4.81367 30.0616 5.42733 30.4443 6.216C30.8316
                                               7.00467 31.0253 7.91933 31.0253 8.96C31.0253 10.0007 30.8316 10.9153 30.4443
                                               11.704C30.0616 12.4927 29.5086 13.1087 28.7853 13.552C28.0666 13.9907 27.2033
                                               14.21 26.1953 14.21ZM26.1953 12.621C26.8719 12.6257 27.4343 12.4763 27.8823
                                               12.173C28.3349 11.8697 28.6733 11.4427 28.8973 10.892C29.1259 10.3413
                                               29.2403 9.69733 29.2403 8.96C29.2403 8.22267 29.1259 7.58333 28.8973 7.042C28.6733
                                               6.496 28.3349 6.07133 27.8823 5.768C27.4343 5.46467 26.8719 5.30833 26.1953 5.299C25.5186
                                               5.29433 24.9563 5.44367 24.5083 5.747C24.0603 6.05033 23.7219 6.47733 23.4933 7.028C23.2693
                                               7.57867 23.1573 8.22267 23.1573 8.96C23.1573 9.69733 23.2693 10.339 23.4933 10.885C23.7173
                                               11.4263 24.0533 11.8487 24.5013 12.152C24.9539 12.4553 25.5186 12.6117 26.1953 12.621Z"
                                                  fill="#E02F2E">

                                            </path>
                                        </svg>
                                    }
                                </div>
                            }

                            @if (column.name === 'Корпорация +' || column.name === 'Корпорация + ФСТЭК') {
                                <div>
                                    <p class="mb-5">Соединений</p>
                                    <div class="tabs advanced-table__tabs">
                                        <div class="tabs__panel advanced-table__number-connections tabs">

                                            @for (numberConnection of numberConnections; track numberConnection) {
                                                <div
                                                    class="tabs__tab advanced-table__number-connection tab"
                                                    [class.active]="numberConnection
                                                    === numberConnections[unit.indexConnections]"
                                                    (click)="onKnowPrice(column, numberConnection)"
                                                >
                                                    <p>{{ numberConnection }}</p>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <app-comparison-editions-select
                                        mode="single"
                                        [units]="numberConnectionsOptions"
                                        (selectionChange)="onEditionSelected(\$event, column)"
                                        [selectedItem]="{id: 1, name: numberConnections[unit.indexConnections]}"
                                    >
                                    </app-comparison-editions-select>
                                </div>
                            }

                        </div>
                    } @else {
                        <span>{{ column.name }}</span>
                    }

                </ng-template>
<!--                [style.gridColumn]="'span ' + (units.length + 1)"-->
                <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                    <ng-container
                        *ngIf="row.isInfinity"
                    >
<!--                        <div *ngIf="unit.field === 'basic'"-->
<!--                             class="merged-cell"-->
<!--                        >-->
                            <h6>Без ограничений</h6>
<!--                        </div>-->
                        <div *ngIf="unit.field !== 'basic'" class="hidden-cell"></div>
                    </ng-container>
                    @if (!row.isInfinity) {
                        @if (row.name === '') {
                            <a
                                [href]="comparisonLinks[unit.field]"
                                class="button"
                                [class.button__normal]="value === 'скачать'"
                                [class.button__red-kind]="value === 'купить'"
                            >
                                {{ value }}
                            </a>
                        } @else {
                            @if (this.dynamicRows.includes(row.name) && editorialBoard[unit.field] !== undefined) {
                                @if (row.name === 'Стоимость') {
                                    @if (unit.indexConnections === 0)  {
                                        <h6>
                                            {{
                                            serverSolutionPricingItems[editorialBoard[unit.field]][unit.indexConnections]
                                              .toLocaleString('ru')
                                            }}
                                        </h6>
                                    } @else {
                                        <h6>Цена по запросу</h6>
                                    }
                                }
                                @if (row.name === 'Количество одновременных управляющих соединений') {
                                    <h6>{{ numberConnections[unit.indexConnections].toLocaleString('ru')}}</h6>
                                }
                            } @else {
                                <div [innerHTML]="numberToLocaleString(value) | keepHtml" class="advanced-table__cell-value"></div>
                            }
                        }
                    }
                </ng-template>
            </ngx-datatable-column>
        }
        <ngx-datatable-footer>
            <ng-template
                    ngx-datatable-footer-template
                    let-rowCount="rowCount"
                    let-pageSize="pageSize"
                    let-selectedCount="selectedCount"
                    let-curPage="curPage"
                    let-offset="offset"
            >
                <div class="comparison-editions__table-custom-footer">
                </div>
            </ng-template>
        </ngx-datatable-footer>
    </ngx-datatable>
</div>
`;
// Exports
export default code;